import Navbar from "@/components/Navbar";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16 prose prose-gray">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Personvernerklæring</h1>
        <p className="text-sm text-gray-500 mb-8">Sist oppdatert: 1. juli 2025</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Behandlingsansvarlig</h2>
          <p className="text-gray-600">
            VeiKlar er behandlingsansvarlig for personopplysningene du gir oss.
            Kontakt oss på: <a href="mailto:hei@veiklar.no" className="text-fjord underline">hei@veiklar.no</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Hvilke opplysninger vi samler inn</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li>Navn og e-postadresse (fra Vipps ved innlogging)</li>
            <li>Telefonnummer (fra Vipps, kun for betalingsformål)</li>
            <li>Betalingsstatus og kjøpshistorikk</li>
            <li>Quizresultater og læringsfremdrift</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Formål med behandlingen</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li>Gi deg tilgang til læringsinnhold du har betalt for</li>
            <li>Lagre din læringsfremdrift</li>
            <li>Behandle betaling via Vipps</li>
            <li>Sende viktige driftsmeldinger om tjenesten</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Rettslig grunnlag</h2>
          <p className="text-gray-600">
            Behandlingen er nødvendig for å oppfylle avtalen med deg (GDPR art. 6 nr. 1 b),
            og for å overholde rettslige forpliktelser (art. 6 nr. 1 c).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Deling med tredjeparter</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li><strong>Vipps AS</strong> – innlogging og betaling</li>
            <li><strong>MongoDB Atlas</strong> – sikker lagring av data i EU</li>
            <li>Vi selger aldri dine opplysninger til tredjeparter</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Lagringstid</h2>
          <p className="text-gray-600">
            Vi lagrer dine opplysninger så lenge du har en aktiv konto, eller inntil
            du ber om sletting. Regnskapsinformasjon oppbevares i 5 år i henhold til
            bokføringsloven.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Dine rettigheter</h2>
          <p className="text-gray-600 mb-2">Du har rett til å:</p>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li>Få innsyn i hvilke opplysninger vi har om deg</li>
            <li>Få rettet feilaktige opplysninger</li>
            <li>Få slettet dine opplysninger</li>
            <li>Klage til Datatilsynet (datatilsynet.no)</li>
          </ul>
          <p className="text-gray-600 mt-2">
            Send forespørsler til: <a href="mailto:hei@veiklar.no" className="text-fjord underline">hei@veiklar.no</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Informasjonskapsler (cookies)</h2>
          <p className="text-gray-600">
            Vi bruker én øktcookie (<code>session_token</code>) for å holde deg innlogget.
            Ingen sporings- eller reklamecookies brukes.
          </p>
        </section>
      </main>
    </div>
  );
}
